import { Component, Input, OnInit } from '@angular/core';
import { DateTimeHelper } from '../../../../helper/date-time.helper';
import { LOCALE_KEY } from '../../../../services/user-service/user-token.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { RelatedLeadsHistory } from '../../../../models/contacts/contacts.model';
import { LeadHelper } from '../../../../helper/lead.helper';

@Component({
  selector: 'fi-related-leads-history',
  templateUrl: './related-leads-history.component.html',
  styleUrls: ['./related-leads-history.component.scss'],
  standalone: false,
})
export class RelatedLeadsHistoryComponent implements OnInit {

  @Input() history: RelatedLeadsHistory[];

  actionHelper = ActionIconHelper;
  dateTimeHelper = DateTimeHelper;
  language: string;

  protected readonly LeadHelper = LeadHelper;

  ngOnInit(): void {
    this.language = this.getLanguage()
  }

  getLanguage(): string {
    return sessionStorage.getItem(LOCALE_KEY);
  }

}
